export const names = [
  "Adobe Creative Suite (Adobe Photoshop, Illustrator, InDesign, etc.)",
      "Typography",
      "Layout Design",
      "Color Theory",
      "Visual brand identities",
      "Illustration",
      "Custom graphics",
      "Image Editing and Retouching",
      "Print Design",
      "User Interface (UI) Design",
      "Web Design",
      "Information Design",
      "Wireframing",
      "Interaction Design",
      "Prototyping",
      "Adobe XD",
      "Sketch",
      "Figma",
      "InVision",
      "Heatmaps: Microsoft Clarity, Hotjar, Crazy Egg",
      "Data Analysis",
      "Google Analytics",
      "Mixpanel",
      "Responsive Design",
      "Accessibility Design",
      "Financial Statement Analysis",
      "Financial Ratio Analysis",
      "Financial Modeling",
      "Valuation Techniques",
      "Risk Analysis",
      "Capital Budgeting",
      "Cost Analysis",
      "Financial Forecasting",
      "Investment Analysis",
      "Corporate Finance",
      "Financial modeling software",
      "Statistical analysis software",
      "Data visualization tools",
      "React Native",
      "Flutter",
      "Xamarin",
      "Ionic",
      "SwiftUI",
      "NativeScript",
      "Network Security",
      "Network protocols",
      "Firewalls",
      "Intrusion detection systems (IDS) and Intrusion prevention systems (IPS)",
      "Virtual private networks (VPNs)",
      "Vulnerability Assessment",
      "Penetration Testing",
      "Incident Response",
      "Embedded Systems",
      "Raspberry Pi",
      "Arduino",
      "Wireless Protocols",
      "IoT Platforms",
      "Amazon Web Services (AWS)",
      "Microsoft Azure",
      "Google Cloud Platform (GCP)",
      "IBM Cloud",
      "Cloud Infrastructure",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Serverless Computing",
      "AWS Lambda",
      "Azure Functions",
      "Data Cleaning",
      "Data Wrangling",
      "Data Visualization",
      "Statistical Modeling",
      "Predictive Modeling",
      "Machine Learning",
      "Deep Learning",
      "Big Data Technologies",
      "Data Warehousing",
      "React Native",
      "Flutter",
      "Xamarin",
      "Ionic",
      "SwiftUI",
      "NativeScript",
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Angular",
      "Vue.js",
      "Sass/Less",
      "TypeScript",
      "Bootstrap",
      "Material-UI",
      "Tailwind CSS",
      "Node.js",
      "Express.js",
      "Ruby on Rails",
      "Django",
      "Flask",
      "ASP.NET",
      "Spring Boot",
      "Laravel",
      "Amazon Web Services (AWS)",
      "Microsoft Azure",
      "Google Cloud Platform (GCP)",
      "IBM Cloud",
      "Cloud Infrastructure",
      "Containerization",
      "Docker",
      "Kubernetes",
      "Serverless Computing",
      "AWS Lambda",
      "Azure Functions",
      "Unity",
      "Unreal Engine",
      "CryEngine",
      "Godot Engine",
      "Blockchain Fundamentals",
      "Smart Contracts",
      "Decentralized Applications (DApps)",
      "Cryptocurrency Mining",
      "Crypto Wallets",
      "Machine Learning Algorithms",
      "Deep Learning Architecture",
      "Natural Language Processing (NLP)",
      "OpenCV",
      "TensorFlow",
      "PyTorch",
      "OpenAI Gym",
      "Stable Baselines",
      "RLlib",
      "Network Security",
      "Network protocols",
      "Firewalls",
      "Intrusion detection systems (IDS) and Intrusion prevention systems (IPS)",
      "Virtual private networks (VPNs)",
      "Vulnerability Assessment",
      "Penetration Testing",
      "Incident Response",
      "Windows",
      "Linux",
      "macOS",
      "Unix",
      ,
      "Unreal Engine",
      "CryEngine",
      "ARKit",
      "ARCore",
      "Vuforia",
      "Manual Testing",
      "Automated Testing",
      "Unit Testing",
      "Integration Testing",
      "System Testing",
      "Acceptance Testing",
      "Load Testing",
      "Performance Testing",
      "Security Testing",
      "Apache HTTP Server",
      "Nginx",
      "Microsoft IIS",
      "Tomcat",
      "Relational Databases",
      "NoSQL Databases",
      "Database Design",
      "SQL Query Optimization",
      "Database Administration",
      "Database Security",
      "Business Strategy",
      "Market Research",
      "Startup Fundraising",
      "Product Development",
      "Lean Startup Methodology",
      "Customer Development",
      "Sales and Marketing",
      "Business Model Canvas",
      "Pitch Deck Creation",
      "Continuous Integration (CI)",
      "Continuous Deployment (CD)",
      "Configuration Management",
      "Containerization",
      "Orchestration Tools",
      "Monitoring and Logging",
      "Infrastructure as Code (IaC)",
      "Version Control Systems",
      "DevSecOps"

  ]
  ;
